import {Head, Link} from '@inertiajs/react';
import {Row, Col, Form, Image} from "react-bootstrap";

const HeroBanner = () => {
    return (
        <>
            <div className="banner-area bg-img pb-0" id="home">
                <div className="container position-relative z-1">
                    <div className="banner-content text-center pb-75">
                        <h1 className="fs-60 mb-3 pb-md-3">
                            YV Teacher Centre & Music Room
                        </h1>

                        <p className="fs-18 m-auto mb-3 pb-md-3 mw-740">
                            We're the heartbeat of music for primary schools across the UK, where children and teachers
                            unite in an electrifying choir experience. Through our unforgettable concerts, children
                            discover their voices, gain confidence and create lasting memories.
                        </p>

                        <Row className="justify-content-center mt-4">
                            <Col md={5} className="mb-4 mb-md-0">
                                <div className="card text-center border-0 shadow p-4 rounded-3 h-100">
                                    <div className="card-body d-flex flex-column align-items-center">
                                        <div className="d-flex align-items-center mb-4">
                                            <Image
                                                src="/images/yv_logo_icon.svg"
                                                alt="logo"
                                                width={50}
                                                height={50}
                                                className="me-2"
                                            />
                                            <h3 className="d-inline m-0 text-yv-secondary">Teacher Centre</h3>
                                        </div>
                                        <a
                                            href={route('auth.teacher.getLogin')}
                                            className="btn btn-yv-primary py-2 px-4 fs-16 fw-medium rounded-3 w-100 mt-auto"
                                        >
                                            <i className="ri-user-line fs-18"></i>
                                            <span className="ms-1">Login / Sign Up as Teacher</span>
                                        </a>
                                    </div>
                                </div>
                            </Col>
                            <Col md={5}>
                                <div className="card text-center border-0 shadow p-4 rounded-3 h-100">
                                    <div className="card-body d-flex flex-column align-items-center">
                                        <div className="d-flex align-items-center mb-4">
                                            <Image
                                                src="/images/yv_logo_icon.svg"
                                                alt="logo"
                                                width={50}
                                                height={50}
                                                className="me-2"
                                            />
                                            <h3 className="d-inline m-0 text-yv-secondary">Music Room</h3>
                                        </div>
                                        <a
                                            href={route('auth.parent.getLogin')}
                                            className="btn btn-yv-secondary py-2 px-4 fs-16 fw-medium rounded-3 w-100 mt-auto"
                                        >
                                            <i className="ri-user-line fs-18"></i>
                                            <span className="ms-1">Login / Sign Up as Parent</span>
                                        </a>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className="banner-img-wrap text-center pb-5 border-bottom mb-5">
                        <Image
                            src="/images/landing/yv_arena_hero.jpg"
                            alt="banner-img"
                            width={848}
                            height={585}
                        />
                    </div>

                    {/* Shape Images */}
                    <Image
                        src="/images/landing/shape-3.png"
                        className="shape shape-7"
                        alt="shape"
                        width={685}
                        height={685}
                    />
                    <Image
                        src="/images/landing/shape-4.png"
                        className="shape shape-8"
                        alt="shape"
                        width={447}
                        height={453}
                    />
                    <Image
                        src="/images/landing/shape-5.png"
                        className="shape shape-9"
                        alt="shape"
                        width={171}
                        height={171}
                    />
                    <Image
                        src="/images/landing/shape-6.png"
                        className="shape shape-10"
                        alt="shape"
                        width={658}
                        height={656}
                    />
                </div>
            </div>
        </>
    );
};

export default HeroBanner;
